import React from 'react';

import { SingePathIcon } from './SinglePathIcon';

export const Plus = () => (
    <SingePathIcon path="M9.02844 4.05213H5.90047V0.924171C5.90047 0.42654 5.49763 0 4.9763 0C4.45498 0 4.05213 0.402844 4.05213 0.924171V4.07583H0.924171C0.42654 4.07583 0 4.47867 0 5C0 5.52133 0.402844 5.92417 0.924171 5.92417H4.07583V9.07583C4.07583 9.57346 4.47867 10 5 10C5.52133 10 5.92417 9.59716 5.92417 9.07583V5.90047H9.07583C9.57346 5.90047 10 5.49763 10 4.9763C10 4.45498 9.54976 4.05213 9.02844 4.05213Z" />
);

Plus.viewBox = `0 0 10 10`;
